import styled from 'styled-components';
import { SCREEN_SM } from 'shared/consts/styleValues';

export const SlotsContainer = styled.div`
	display: grid;
	grid-template-columns: 170px 69px minmax(50px, auto);
	align-items: center;
	gap: 8px;
	margin-left: 15px;
	margin-right: 15px;
  

	@media (min-width: ${SCREEN_SM}px) {
    justify-content: space-between;
	}
`;
